import * as React from "react";

export const useMount = (fn: () => void) => {
  React.useEffect(
    () => {
      fn();
    },
    // Want to simulate a mount effect here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
};
